import { createApi } from 'unsplash-js';

export const UNSPLASH_ACCESS_KEY = process.env.REACT_APP_UNSPLASH_API_KEY || '';

const unsplash = createApi({
    accessKey: UNSPLASH_ACCESS_KEY
});

export async function trackUnsplashDownload(downloadLocation: string): Promise<void> {
    if (!downloadLocation || !UNSPLASH_ACCESS_KEY) {
        console.warn('Unsplash download tracking skipped - missing API key or download location');
        return;
    }

    unsplash.photos
        .trackDownload({ downloadLocation: downloadLocation })
        .then((response) => {
            console.log('response', response);
            if (response.type === 'success') {
                const imageUrl = response.response.url;
                const img = new Image();
                img.src = imageUrl;
                img.style.display = 'none';
                document.body.appendChild(img);
                console.log('Download tracker triggered successfully!');
            } else {
                console.error('Failed to trigger download tracker:', response.errors);
            }
        })
        .catch((error) => {
            console.error('Error triggering download tracker:', error);
        });
}
